<template>
  <Modal title="Work Complete" @hide-modal="$emit('hide-modal')">
    <div
      v-if="invoice.signature"
      :class="{ 'signature-container': invoice.signature.image_url }"
    >
      <img
        v-if="invoice.signature.image_url"
        :src="invoice.signature.image_url"
        alt="Signature"
      />
      <div v-else>Manually Approved</div>
    </div>
    <div v-else>
      <p class="mb-4">
        This invoice requires a work complete signature. As an admin you can
        manually approve the work on behalf of the customer with reason.
      </p>
      <form @submit.prevent="handleApprove">
        <label class="full-width">
          Approval Reason
          <textarea
            v-model="approvalNote"
            class="form-control full-width"
          ></textarea>
        </label>
      </form>
    </div>
    <template #submit>
      <div v-if="invoice.signature"></div>
      <Button
        v-else
        class="ml-4"
        :disabled="!approvalNote || saving"
        data-cy="modal-submit-btn"
        @click="handleApprove"
      >
        <span v-if="!saving">Complete Work</span>
        <Spinner v-else message="Saving..."></Spinner>
      </Button>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";

import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Modal,
    Spinner,
    Button
  },
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      approvalNote: "",
      saving: false
    };
  },
  methods: {
    ...mapActions(["approveInvoice"]),
    handleApprove() {
      if (this.approvalNote) {
        this.saving = true;
        this.approveInvoice({
          invoice: this.invoice,
          reason: this.approvalNote
        })
          .then(() => {
            this.saving = false;
            this.$emit("hide-modal");
            window.notify.success("Work complete successfully overridden!");
          })
          .catch(() => (this.saving = false));
      }
    }
  }
};
</script>
